export const Images = {
  companyLogo: require("./images/JustAct_Logo_TM_V4-01.png"),
  // companyLogoWhite: require("./images/company-logo-white.png"),
  companyLogoWhite: require("./images/JustAct_Logo_TM_V5-04.png"),
  selectArrow: require("./images/selectArrow.svg"),
  checkBox: require("./images/checkbox.svg"),
  checkBoxSelected: require("./images/checkBoxSelected.svg"),
  dropDownArrow: require("./images/dropdownIcon.svg"),
  filefloder: require("./images/files-and-folders.svg"),
  CaseManagement: require("./images/Case-managment.png"),
  CloudBasedOdr: require("./images/Colud-based-odr.png"),
  LoanDispute: require("./images/Loan-dispute.png"),
  Transcription: require("./images/Transcription.png"),
  AboutJustact: require("./images/about-justact.png"),
  Negotiation: require("./images/negotiation.png"),
  Mediation: require("./images/mediation.png"),
  Arbitration: require("./images/arbitration.png"),
  Saas: require("./images/Saas.png"),
  JusticeKannan: require("./images/Justice-kannan.png"),
  Karthik: require("./images/karthik-krishna.png"),
  VirenNanavati: require("./images/Viren-nanavati.png"),
  NlRaja: require("./images/Nl-raja.png"),
  FasterResolution: require("./images/FasterResolution.png"),
  SignificantCost: require("./images/SignificantCost.png"),
  Scalability: require("./images/Scalability.png"),
  RemoteAccess: require("./images/RemoteAccess.png"),
  LegallySound: require("./images/LegallySound.png"),
  ClientNeutral: require("./images/ClientNeutral.png"),
  IconDate: require("./images/Date.png"),
  IconFrame: require("./images/Frame.png"),
  CommercialDisputes: require("./images/Commercial-disputes-01.png"),
  FamilyDisputes: require("./images/Family-disputes-01.png"),
  JustActMailers: require("./images/Justact-mailers-expert-01.png"),
  CredibleLegal: require("./images/Credible-Legal.png"),
  ClientIntegrated: require("./images/Client-integrate.png"),
  AiPowered: require("./images/Ai-powerd.png"),
  EnforceabilityExecution: require("./images/Enforceability-execution.png"),
  CuratedArbitrator: require("./images/Curated-arbitrator.png"),
  EmpanelmentOne: require("./images/Empanelment-one.png"),
  EmpanelmentTwo: require("./images/Empanelment-two.png"),
  EmpanelmentThree: require("./images/Empanelment-three.png"),
  EmpanelmentFour: require("./images/Empanelment-four.png"),
  EmpanelmentFive: require("./images/Empanelment-five.png"),
  Rahul: require("./images/Rahul.png"),
  Madhav: require("./images/Madhv.png"),
  Login: require("./images/Login.png"),
  Webinar: require("./images/webiniar.png"),
  blog: require("./images/blog.png"),
  modalClause: require("./images/modal-clause.png"),
  arbitrator: require("./images/neutrals.png"),
  mediator: require("./images/mediator.png"),
  shortProgram: require("./images/corporate-short-programme.png"),
  longProgram: require("./images/long-program.png"),
  worldMediation: require("./images/world-of-mediation.png"),
  independent: require("./images/independent.jpg"),
  technology: require("./images/technology.jpg"),
  professionals: require("./images/professionals.jpg"),
  agreement: require("./images/agreement.jpg"),
  fdcr: require("./images/fdcr.jpg"),
  npac: require("./images/npac.jpg"),
};
